/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalIdentification
 */
export interface AdditionalIdentification {
    /**
     * 
     */
    identifier?: string;
    /**
     * 
     */
    identifier_code?: string;
    /**
     * 
     */
    identifier_code_definition?: string;
    /**
     * 
     */
    description?: string;
}

/**
 * Check if a given object implements the AdditionalIdentification interface.
 */
export function instanceOfAdditionalIdentification(value: object): value is AdditionalIdentification {
    return true;
}

export function AdditionalIdentificationFromJSON(json: any): AdditionalIdentification {
    return AdditionalIdentificationFromJSONTyped(json, false);
}

export function AdditionalIdentificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalIdentification {
    if (json == null) {
        return json;
    }
    return {
        
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'identifier_code': json['identifier_code'] == null ? undefined : json['identifier_code'],
        'identifier_code_definition': json['identifier_code_definition'] == null ? undefined : json['identifier_code_definition'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function AdditionalIdentificationToJSON(json: any): AdditionalIdentification {
    return AdditionalIdentificationToJSONTyped(json, false);
}

export function AdditionalIdentificationToJSONTyped(value?: AdditionalIdentification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identifier': value['identifier'],
        'identifier_code': value['identifier_code'],
        'identifier_code_definition': value['identifier_code_definition'],
        'description': value['description'],
    };
}

